import component from './component';

const moduleName = 'ovhLogToCustomerSelectKinds';

angular.module(moduleName, []).component(component.name, component);

export default moduleName;
